module.exports = __webpack_public_path__ + "img/task-view-button.7c2cde13.png";